import { Mensaje } from "@/components/mensajes2";
import { Dimmer } from "@/components/spinner";
import { Checkbox } from "@/ui/inputs/Input";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { utils, writeFile } from "xlsx";
import { formatoFecha } from "@/util/varios";
import CatalogoActividadEconomica from "@/catalogos/catalogoActividadEconomica";

const ModalImprimirContriDecla = (props) => {
  const op = require("@/modulos/datos");
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const fechaActual = new Date().toISOString().split("T")[0];
  const [mes, setMes] = useState();
  const [anio, setAnio] = useState();
  const [selectActividad, setSelectActividad] = useState({
    id: "",
    descripcion: "",
  });
  const [showActividad, setShowActividad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orden, setOrden] = useState("desc");
  const [tipo, setTipo] = useState("periodo");
  const [desde, setDesde] = useState(fechaActual);
  const [hasta, setHasta] = useState(fechaActual);
  const [filtros, setFiltros] = useState({
    activo: true,
    variable: "DECLARADO",
    montoDesde: 0,
    montoHasta: 0,
  });
  const [todos, setTodos] = useState(false);
  const [actividad, setActividad] = useState("todas");
  const [moneda, setMoneda] = useState("BOLIVARES");
  const [simbolo, setSimbolo] = useState("BS");
  const [cantidad, setCantidad] = useState(10);
  const [detallado, setDetallado] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const MESES = [
    { value: "1", label: "ENERO" },
    { value: "2", label: "FEBRERO" },
    { value: "3", label: "MARZO" },
    { value: "4", label: "ABRIL" },
    { value: "5", label: "MAYO" },
    { value: "6", label: "JUNIO" },
    { value: "7", label: "JULIO" },
    { value: "8", label: "AGOSTO" },
    { value: "9", label: "SEPTIEMBRE" },
    { value: "10", label: "OCTUBRE" },
    { value: "11", label: "NOVIEMBRE" },
    { value: "12", label: "DICIEMBRE" },
  ];
  const imprimirFecha = () => {
    let limit = cantidad;
    if (todos) limit = 999999;
    const ordenamiento =
      filtros.variable === "DECLARADO"
        ? "montodeclarado"
        : filtros.variable === "PAGAR_B"
          ? "monto_pagar_bs"
          : "montopag_d";
    const parametro =
      filtros.variable === "DECLARADO"
        ? "montodeclarado"
        : filtros.variable === "PAGAR_B"
          ? "monto_pagar_bs"
          : "montopag_d";
    const condicion =
      filtros.activo && !detallado
        ? `${parametro} between ${limpiarParaSQL(filtros.montoDesde)} and ${limpiarParaSQL(filtros.montoHasta)}
        ${
          selectActividad.descripcion
            ? ` and idactividad =  ${selectActividad.id}`
            : ""
        }
        `
        : "1=1";
    window.open(
      `${op.reportes}/actividadeconomica?reporte=DeclaracionContribu&desde=${desde}&hasta=${hasta}&orden=${ordenamiento} ${orden}&cantidad=${limit}&condicion=${encodeURIComponent(condicion)}&ACTIVIDAD=${selectActividad.descripcion}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const imprimirPeriodo = () => {
    let limit = cantidad;
    if (todos) limit = 999999;
    const ordenamiento =
      filtros.variable === "DECLARADO"
        ? "montodeclarado"
        : filtros.variable === "PAGAR_B"
          ? "monto_pagar_bs"
          : "montopag_d";
    const parametro =
      filtros.variable === "DECLARADO"
        ? "montodeclarado"
        : filtros.variable === "PAGAR_B"
          ? "monto_pagar_bs"
          : "montopag_d";
    const condicion =
      filtros.activo && !detallado
        ? `${parametro} between ${limpiarParaSQL(filtros.montoDesde)} and ${limpiarParaSQL(filtros.montoHasta)}
        `
        : "1=1";
    const actividad = selectActividad.descripcion
      ? ` idactividad = ${selectActividad.id}`
      : "1=1";

    window.open(
      `${op.reportes}/actividadeconomica?reporte=ContribuyentesDeclarados&anio=${parseInt(anio)}&mes=${parseInt(mes)}&orden=${ordenamiento} ${orden}&cantidad=${limit}&condicion=${encodeURIComponent(condicion)}&ACTIVIDAD=${selectActividad.descripcion}&CONDI_ACTIVIDAD=${actividad}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const reporteDetallado = () => {
    window.open(
      op.reportes +
        "/actividadeconomica?" +
        `reporte=Listado_Deuda_Comercio&ANIO= anio =${anio}&moneda=${moneda}&simbolo=${simbolo}&CONDICION=and 1=1&ORDEN=${orden}&LIMIT=${cantidad}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const reporteExcelFecha = async () => {
    try {
      let limit = cantidad;
      if (todos) limit = 999999;
      const ordenamiento =
        filtros.variable === "DECLARADO"
          ? "montodeclarado"
          : filtros.variable === "PAGAR_B"
            ? "monto_pagar_bs"
            : "montopag_d";
      let formulaSQL = "";
      if (filtros.variable === "DECLARADO") {
        formulaSQL = "sum(d.montodeclarado)";
      } else if (filtros.variable === "PAGAR_B") {
        formulaSQL = "sum(d.montoapagar)";
      } else {
        formulaSQL = `round(sum(d.montoapagar / coalesce(
        m.valor,
        (select valor from monedadetalle where fecha::date <= d.fechadeclaracion::date and valor is not null order by fecha::date desc limit 1),
        (select valor from monedadetalle where fecha::date >= d.fechadeclaracion::date and valor is not null order by fecha::date asc limit 1)
      )), 2)`;
      }
      const havingCondicion =
        filtros.activo && !detallado
          ? ` having ${formulaSQL} between ${limpiarParaSQL(filtros.montoDesde)} and ${limpiarParaSQL(filtros.montoHasta)}`
          : "";
      const condicion = selectActividad.descripcion
        ? ` and dj.idactividad =  ${selectActividad.id}`
        : "";
      setLoading(true);
      const campos = `
      c.idcomercio, c.rif, c.nombre as razonsocial,
      sum(d.montodeclarado) as montodeclarado,
      sum(d.montopetro) as montopag_u,
      sum(d.montoapagar) as montopag,
      round(sum(d.montoapagar / coalesce(
              m.valor,
              (select valor from monedadetalle where fecha::date <= d.fechadeclaracion::date and valor is not null order by fecha::date desc limit 1),
              (select valor from monedadetalle where fecha::date >= d.fechadeclaracion::date and valor is not null order by fecha::date asc limit 1)
          )), 2) as montopag_d
    `;

      // 3. El WHERE maneja las fechas (eso es correcto). El HAVING se agrega abajo del GROUP BY
      const nomtab = `
      comercio c
      inner join djurada d on d.idcomercio = c.idcomercio
      left join monedadetalle m on m.fecha::date = d.fechadeclaracion::date
      where d.fechadeclaracion between '${desde}'::text::date and '${hasta}'::text::date
      group by c.idcomercio, c.rif, c.nombre
      ${havingCondicion} ${condicion}
    `;

      const orde = `
      ${ordenamiento} ${orden}
      limit ${limit}::int
    `;

      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(nomtab)}&orden=${encodeURIComponent(orde)}`;

      await axios.get(endpoint).then((response) => {
        const { data } = response;
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Contribuyentes");
        writeFile(
          workbook,
          `Contribuyentes-Declarados-Fecha-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`,
        );
      });
    } catch (error) {
      console.log(error);
      setMensaje({
        mostrar: true,
        titulo: "",
        texto:
          "Error al Generar el excel de Contribuyentes con mas Declaraciones por Fecha",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const reporteExcelPeriodo = async () => {
    try {
      let limit = cantidad;
      if (todos) limit = 999999;
      const ordenamiento =
        filtros.variable === "DECLARADO"
          ? "montodeclarado"
          : filtros.variable === "PAGAR_B"
            ? "monto_pagar_bs"
            : "montopag_d";
      let formulaSQL = "";
      if (filtros.variable === "DECLARADO") {
        formulaSQL = "sum(d.montodeclarado)";
      } else if (filtros.variable === "PAGAR_B") {
        formulaSQL = "sum(d.montoapagar)";
      } else {
        formulaSQL = `round(sum(d.montoapagar / coalesce(
        m.valor,
        (select valor from monedadetalle where fecha::date <= d.fechadeclaracion::date and valor is not null order by fecha::date desc limit 1),
        (select valor from monedadetalle where fecha::date >= d.fechadeclaracion::date and valor is not null order by fecha::date asc limit 1)
      )), 2)`;
      }
      const havingCondicion =
        filtros.activo && !detallado
          ? ` having ${formulaSQL} between ${limpiarParaSQL(filtros.montoDesde)} and ${limpiarParaSQL(filtros.montoHasta)}`
          : "";
      const condicion = selectActividad.descripcion
        ? ` and d.idactividad =  ${selectActividad.id}`
        : "";
      setLoading(true);
      const campos = `
      c.idcomercio, c.rif, c.nombre as razonsocial, d.mes as nom_mes, c.direccion,
      sum(d.montodeclarado) as montodeclarado,
      sum(d.montopetro) as montopag_u,
      sum(d.montoapagar) as monto_pagar_bs,
      sum(d.montoapagar) as montopag,
      round(sum(d.montoapagar / coalesce(
              m.valor,
              (select valor from monedadetalle where fecha::date <= d.fechadeclaracion::date and valor is not null order by fecha::date desc limit 1),
              (select valor from monedadetalle where fecha::date >= d.fechadeclaracion::date and valor is not null order by fecha::date asc limit 1)
          )), 2) as montopag_d
    `;
      const nomtab = `
      comercio c
      inner join djurada d on d.idcomercio = c.idcomercio
      left join monedadetalle m on m.fecha::date = d.fechadeclaracion::date
      where d.nummes = ${mes}::int and d.anio = ${anio}::int ${condicion}
      group by c.idcomercio, c.rif, c.nombre, d.mes
      ${havingCondicion}
    `;

      const orde = `
      ${ordenamiento} ${orden}
      limit ${limit}::int
    `;

      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(nomtab)}&orden=${encodeURIComponent(orde)}`;

      await axios.get(endpoint).then((response) => {
        const { data } = response;
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Contribuyentes");
        writeFile(
          workbook,
          `Contribuyentes-Declarados-Periodo-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`,
        );
      });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "",
        texto:
          "Error al Generar el excel de Contribuyentes con mas Declaraciones por Periodo",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const reporteExcelDetallado = async () => {
    try {
      setLoading(true);
      const campos = `
      dj.idcomercio,
    c.nombre,
    c.ritm,
    c.numerolicencia,
    c.direccion,
    dj.anio,
    
    -- ENERO
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'ENERO'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'ENERO'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'ENERO'), 2)
END, 0) AS monto_ene,

-- FEBRERO
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'FEBRERO'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'FEBRERO'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'FEBRERO'), 2)
END, 0) AS monto_feb,

-- MARZO
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'MARZO'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'MARZO'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'MARZO'), 2)
END, 0) AS monto_mar,

-- ABRIL
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'ABRIL'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'ABRIL'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'ABRIL'), 2)
END, 0) AS monto_abr,

-- MAYO
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'MAYO'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'MAYO'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'MAYO'), 2)
END, 0) AS monto_may,

-- JUNIO
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'JUNIO'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'JUNIO'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'JUNIO'), 2)
END, 0) AS monto_jun,

-- JULIO
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'JULIO'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'JULIO'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'JULIO'), 2)
END, 0) AS monto_jul,

-- AGOSTO
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'AGOSTO'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'AGOSTO'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'AGOSTO'), 2)
END, 0) AS monto_ago,

-- SEPTIEMBRE
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'SEPTIEMBRE'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'SEPTIEMBRE'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'SEPTIEMBRE'), 2)
END, 0) AS monto_sep,

-- OCTUBRE
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'OCTUBRE'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'OCTUBRE'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'OCTUBRE'), 2)
END, 0) AS monto_oct,

-- NOVIEMBRE
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'NOVIEMBRE'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'NOVIEMBRE'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'NOVIEMBRE'), 2)
END, 0) AS monto_nov,

-- DICIEMBRE
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD'  THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes = 'DICIEMBRE'), 2)
    WHEN 'BOLIVARES'    THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes = 'DICIEMBRE'), 2)
    WHEN 'DOLAR'  THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes = 'DICIEMBRE'), 2)
END, 0) AS monto_dic,

-- TOTAL ANUAL
COALESCE(CASE '${moneda}'
    WHEN 'UNIDAD' THEN ROUND(SUM(dj.montopetro) FILTER (WHERE mes IN ('ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE')), 2)
    WHEN 'BOLIVARES' THEN ROUND(SUM(dj.montoapagar) FILTER (WHERE mes IN ('ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE')), 2)
    WHEN 'DOLAR' THEN ROUND(SUM(dj.montoapagar / md.valor) FILTER (WHERE mes IN ('ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE')), 2)
END, 0) AS monto_total_anual
      
      `;
      const condicion = selectActividad.descripcion
        ? ` and dj.idactividad =  ${selectActividad.id}`
        : "";
      const nomtab = `
      djurada dj
INNER JOIN comercio c ON c.idcomercio = dj.idcomercio
INNER JOIN LATERAL (
    SELECT valor 
    FROM monedadetalle 
    WHERE fecha::date <= dj.fechadeclaracion
    ORDER BY fecha DESC 
    LIMIT 1
) md ON true
WHERE anio=${anio} ${condicion}
GROUP BY dj.idcomercio, c.nombre, c.ritm, c.numerolicencia, dj.anio, c.direccion
      `;
      const orde = `
      monto_total_anual ${orden}, idcomercio ${orden}, anio ${orden}
limit ${cantidad}
      `;
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(nomtab)}&orden=${encodeURIComponent(orde)}`;
      await axios.get(endpoint).then((response) => {
        const { data } = response;
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "SinDeclarar"); // Nombre de la pestaña
        writeFile(
          workbook,
          `Contribuyentes-Declarados-${moneda}-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`, // Nombre del archivo
        );
      });
    } catch (error) {
      console.log(error);
      setMensaje({
        mostrar: true,
        titulo: "",
        texto:
          "Error al Generar el excel de Contribuyentes con mas Declaraciones",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const aceptarActividad = (idActi, codciu, codacti, descrip) => {
    setShowActividad(false);
    setSelectActividad({
      id: idActi,
      descripcion: `${codciu.trim()} - ${descrip.trim()}`,
    });
  };
  const handleInputMontoChange = (event) => {
    const { name, value } = event.target;
    const soloNumeros = value.replace(/\D/g, "");
    if (soloNumeros === "") {
      setFiltros((prev) => ({
        ...prev,
        [name]: "",
      }));
      return;
    }
    const numeroDecimal = (parseInt(soloNumeros, 10) / 100).toFixed(2);
    const formateado = Number(numeroDecimal).toLocaleString("es-VE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    setFiltros((prev) => ({
      ...prev,
      [name]: formateado,
    }));
  };
  const limpiarParaSQL = (valor) => {
    if (!valor) return "0";
    return valor.toString().replace(/\./g, "").replace(",", ".");
  };
  const salir = () => {
    blanquear();
    props.onHide();
  };
  const blanquear = () => {
    setMes();
    setAnio();
    setOrden("desc");
    setTipo("periodo");
    setDesde(fechaActual);
    setHasta(fechaActual);
    setTodos(false);
    setCantidad(10);
    setDetallado(false);
    setMoneda("BOLIVARES");
    setSimbolo("BS");
    setSelectActividad({
      id: "",
      descripcion: "",
    });
    setActividad("todas");
    setShowActividad(false);
    setFiltros({
      activo: false,
      variable: "DECLARADO",
      montoDesde: 0,
      montoHasta: 0,
    });
  };
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      show={props.show}
      onShow={() => {
        const { cantidad, mes, anio, filtroTipo, desde, hasta, todos } = props;
        setCantidad(cantidad);
        setMes(mes);
        setAnio(anio);
        setOrden("desc");
        setTipo(filtroTipo);
        setDesde(desde ? desde : fechaActual);
        setHasta(hasta ? hasta : fechaActual);
        setTodos(todos);
        setFiltros({
          activo: false,
          variable: "DECLARADO",
          montoDesde: 0,
          montoHasta: 0,
        });
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          Imprimir Contribuyentes Declarados
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-around row">
          <div className="d-flex justify-content-end col-md-12">
            <div className="col-md-4 py-2 ml-auto">
              <Checkbox
                label="Reporte Detallado Anual"
                name="detallado"
                id="detallado"
                checked={detallado}
                onChange={(e) => {
                  setSelectActividad({
                    id: "",
                    descripcion: "",
                  });
                  setActividad("todas");
                  setDetallado(e.target.checked);
                  setFiltros((prev) => ({
                    ...prev,
                    activo: false,
                  }));
                }}
              />
            </div>
            <div className="col-md-4 py-2 ml-auto">
              <Checkbox
                label="Filtros de Reporte"
                name="filtros"
                id="filtros"
                checked={filtros.activo}
                onChange={(e) => {
                  setFiltros((prev) => ({
                    ...prev,
                    activo: e.target.checked,
                  }));
                  setDetallado(false);
                }}
              />
            </div>
          </div>
          {detallado && (
            <fieldset className="col-md-11 border-azul rounded m-auto">
              <legend
                className="float-none w-auto fw-bold text-uppercase"
                style={{
                  fontSize: "0.9rem",
                }}
              >
                Tipo de Moneda
              </legend>
              <div className="row justify-content-center text-center">
                <div className=" mb-2 col-md-4">
                  <div className="form-check d-inline-flex align-items-center">
                    <label className="form-check-label d-flex align-items-center">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name="tipoReporte"
                        value="BOLIVARES"
                        checked={moneda === "BOLIVARES"}
                        onChange={(e) => {
                          setMoneda(e.target.value);
                          setSimbolo("Bs");
                        }}
                      />
                      Bolivares (Bs)
                    </label>
                  </div>
                </div>
                <div className=" mb-2 col-md-4">
                  <div className="form-check d-inline-flex align-items-center">
                    <label className="form-check-label d-flex align-items-center">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name="tipoReporte"
                        value="UNIDAD"
                        checked={moneda === "UNIDAD"}
                        onChange={(e) => {
                          setMoneda(e.target.value);
                          setSimbolo("€");
                        }}
                      />
                      Unidad (€)
                    </label>
                  </div>
                </div>
                <div className=" mb-2 col-md-4">
                  <div className="form-check d-inline-flex align-items-center">
                    <label className="form-check-label d-flex align-items-center">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name="tipoReporte"
                        value="DOLAR"
                        checked={moneda === "DOLAR"}
                        onChange={(e) => {
                          setMoneda(e.target.value);
                          setSimbolo("$");
                        }}
                      />
                      Dolar ($)
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
          )}
          <fieldset className="col-md-11 border-azul rounded m-auto">
            <legend
              className="float-none w-auto fw-bold text-uppercase"
              style={{
                fontSize: "0.9rem",
              }}
            >
              Parametros
            </legend>
            <div className="row justify-content-center text-center">
              {!detallado && (
                <>
                  {tipo === "periodo" ? (
                    <>
                      <div className="input-group input-group-sm mb-2 col-md-4">
                        <span
                          className="input-group-text text-uppercase"
                          id="inputGroup-sizing-sm"
                        >
                          Mes
                        </span>
                        <select
                          className="form-select form-select-sm"
                          value={mes}
                          onChange={(e) => setMes(e.target.value)}
                          autoFocus
                        >
                          {MESES.map((m) => (
                            <option key={m.value} value={m.value}>
                              {m.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="input-group input-group-sm mb-2 col-md-4">
                        <span
                          className="input-group-text text-uppercase"
                          id="inputGroup-sizing-sm"
                        >
                          DESDE:
                        </span>
                        <input
                          type="date"
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          max={fechaActual}
                          value={desde}
                          onChange={(e) => {
                            const { value } = e.target;
                            setDesde(value);
                          }}
                        />
                      </div>
                      <div className="input-group input-group-sm mb-2 col-md-4">
                        <span
                          className="input-group-text text-uppercase"
                          id="inputGroup-sizing-sm"
                        >
                          HASTA:
                        </span>
                        <input
                          type="date"
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          max={fechaActual}
                          value={hasta}
                          onChange={(e) => {
                            const { value } = e.target;
                            setHasta(value);
                          }}
                        />
                      </div>
                    </>
                  )}
                </>
              )}
              {(detallado || tipo === "periodo") && (
                <div className="input-group input-group-sm mb-2 col-md-4">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Año
                  </span>
                  <select
                    className="form-select form-select-sm"
                    value={anio}
                    onChange={(e) => setAnio(e.target.value)}
                  >
                    {anios &&
                      anios.map((e) => (
                        <option key={e} value={e}>
                          {e}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              <div className="input-group input-group-sm mb-2 col-md-4">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  ORDEN
                </span>
                <select
                  className="form-select form-select-sm"
                  value={orden}
                  onChange={(e) => setOrden(e.target.value)}
                >
                  <option key={"desc"} value={"desc"}>
                    Mayor a Menor
                  </option>
                  <option key={"asc"} value={"asc"}>
                    Menor a Mayor
                  </option>
                </select>
              </div>
            </div>
          </fieldset>
          {filtros.activo && !detallado && (
            <fieldset className="col-md-11 border-azul rounded m-auto">
              <legend
                className="float-none w-auto fw-bold text-uppercase"
                style={{
                  fontSize: "0.9rem",
                }}
              >
                Filtros
              </legend>
              <div className="row justify-content-center text-center">
                <div className="row d-flex justify-content-between col-12 p-0 m-0 mb-3">
                  <div className="input-group input-group-sm mb-2 col-md-3">
                    <div className="form-check d-inline-flex align-items-center">
                      <label className="form-check-label d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name="actividad"
                          value="todas"
                          checked={actividad === "todas"}
                          onChange={() => setActividad("todas")}
                        />
                        Todas las Actividades
                      </label>
                    </div>
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-3">
                    <div className="form-check d-inline-flex align-items-center">
                      <label className="form-check-label d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name="actividad"
                          value="una"
                          checked={actividad === "una"}
                          onChange={() => {
                            (setActividad("una"),
                              setSelectActividad({
                                id: "",
                                descripcion: "",
                              }));
                          }}
                        />
                        Por Actividad
                      </label>
                    </div>
                  </div>
                </div>
                {actividad === "una" && (
                  <div className="row d-flex justify-content-between col-12 p-0 m-0 mb-3">
                    <div className="input-group input-group-sm mb-2 col-md-12">
                      <span className="input-group-text">Descripción:</span>
                      <input
                        type="text"
                        className="form-control"
                        value={selectActividad.descripcion}
                        disabled
                      />
                      <button
                        className="btn btn-sm btn-info"
                        onClick={() => setShowActividad(true)}
                      >
                        <i className="fas fa-search" />
                      </button>
                    </div>
                  </div>
                )}
                <div className="row d-flex justify-content-between col-12 p-0 m-0">
                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <span className="input-group-text">Filtrar Por:</span>
                    <select
                      className="form-select form-select-sm"
                      value={filtros.variable}
                      onChange={(e) => {
                        setFiltros((prev) => ({
                          ...prev,
                          variable: e.target.value,
                        }));
                      }}
                    >
                      <option value="DECLARADO">Monto Declarado</option>
                      <option value="PAGAR_B">Monto a Pagar Bs</option>
                      <option value="PAGAR_D">Monto a Pagar $</option>
                    </select>
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {"Monto >= a : "}
                    </span>
                    <input
                      type="text"
                      className="form-control text-right"
                      name="montoDesde"
                      value={filtros.montoDesde}
                      onChange={handleInputMontoChange}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {"Monto <= a : "}
                    </span>
                    <input
                      type="text"
                      className="form-control text-right"
                      name="montoHasta"
                      value={filtros.montoHasta}
                      onChange={handleInputMontoChange}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-sm rounded-pill btn btn-info col-md-2"
          onClick={() => {
            if (detallado) {
              reporteExcelDetallado();
            } else {
              tipo === "periodo" ? reporteExcelPeriodo() : reporteExcelFecha();
            }
          }}
        >
          <i className="fas fa-file"></i> Excel
        </button>
        <button
          onClick={() => {
            if (detallado) {
              reporteDetallado();
            } else {
              tipo === "periodo" ? imprimirPeriodo() : imprimirFecha();
            }
          }}
          className="btn-sm rounded-pill btn btn-primary col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-sign-out"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <CatalogoActividadEconomica
        show={showActividad}
        onHideCancelaCatActi={() => setShowActividad(false)}
        onHideAceptaCatActi={aceptarActividad}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
};

export default ModalImprimirContriDecla;
